module.exports = __webpack_public_path__ + "img/landing-report-background.webp";